import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/Index'
import Login from '@/components/main/Login'
import MobileApps from '@/components/mobileapps/Index'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {path: '/', name: 'Home', component: Home, meta: {forAuth: false}},
    {path: '/login', name: 'Login', component: Login, meta: {forAuth: false}},
    {path: '/mobileapps', name: 'MobileApps', component: MobileApps, meta: {forAuth: true}},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js